export const GACategories = {
  Interstitials: 'offer page',
  AccountNav: 'account_nav',
  AccountHome: 'account_home',
  AccountOrder: 'account_order',
  // Business Toolkit
  BusinessToolkit: 'business_toolkit_mylz',

  // Login
  Login: 'login page',

  // Change Password
  ChangePassword: 'change password',

  // Business Email - Google Workspace
  BusinessEmailDefault: 'business_email_default',
  BusinessEmailEntitled: 'business_email_entitled',
  BusinessEmailPending: 'business_email_pending',
  BusinessEmailCompleted: 'business_email_completed',
  BusinessEmailDismissed: 'business_email_dismissed',

  // Insurance - NEXT
  InsuranceNextDefault: 'insurance_next_default',
  InsuranceNextEntitled: 'insurance_next_entitled',
  InsuranceNextCompleted: 'insurance_next_completed',

  // Banking - Bank of America
  BankingBOADefault: 'bank_of_america_default',
  BankingBOAEntitled: 'bank_of_america_entitled',
  BankingBOACompleted: 'bank_of_america_completed',

  // Website - Wix
  WebsiteDefault: 'website_default',
  WebsiteEntitled: 'website_entitled',
  WebsiteCompleted: 'website_completed',

  // POS - Square
  PosSquareDefault: 'pos_square_default',
  PosSquareEntitled: 'pos_square_entitled',
  PosSquareCompleted: 'pos_square_completed',

  // Template - store
  TemplateStore: 'templates_store',
  DocumentViewer: 'document_viewer',
  FormEsignPurchase: 'form_esign_purchase',

  // Universal Checkout
  UniversalCheckout: 'universal_checkout_page',

  // Testing Only
  Test: 'test',
  TestAlt: 'test alt',
};

export type GACategories = (typeof GACategories)[keyof typeof GACategories];
